import { ScrollRestorationInterface } from '@Types/content/ScrollRestoration';
import { NextRouter } from 'next/router';

export const scrollRestoration = (router: NextRouter) => {
  if (typeof window === 'undefined') return;

  window.history.scrollRestoration = 'manual';

  const scrollRestoration: ScrollRestorationInterface = JSON.parse(sessionStorage.getItem('scrollRestoration'));
  if (scrollRestoration && scrollRestoration.scroll && scrollRestoration.asPath === router.asPath) {
    window.scrollTo({
      top: scrollRestoration.scrollPosition,
      behavior: 'smooth',
    });
  }

  sessionStorage.removeItem('scrollRestoration');
};
